var commonUtils = {
  // base64转化成formdata再上传的方法
  uploadBase64(base64Url) {
    const blob = commonUtils.convertBase64UrlToBlob(base64Url)
    const formData = new FormData()
    formData.append('file', blob)
    formData.append('type', 'image')
    formData.append('fileName', 'screenShot' + new Date().getTime() + '.png')
    // const data = { formData }
    this.$http.post(window.$envUtils('VUE_APP_WB_SERVICE') + '/infinite/currentSession/uploadfile/printscreen', { data: formData }).then(res => {
      const body = { url: res.data.url }
      this.$emit('handleMessage', 'image', body)
    })
  },

  // 将base64Url字符串转化为blob对象的方法
  convertBase64UrlToBlob(urlData) {
    const bytes = window.atob(urlData.split(',')[1]) // 去掉url的头，并转换为byte
    // 处理异常，将ASCII码小于0的转换为大于0
    const ab = new ArrayBuffer(bytes.length)
    const ia = new Uint8Array(ab)
    for (let i = 0; i < bytes.length; i++) {
      ia[i] = bytes.charCodeAt(i)
    }
    return new Blob([ab], { type: 'image/png' })
  },

  // 从一段html标签中提取出<img>的src地址工具方法（入参html字符串）,返回一个url数组，专门用于提取截图的base64图片中的src地址
  getImgSrc(html) {
    const reg = /<img.+?src=('|")?([^'"]+)('|")?(?:\s+|>)/gim
    let tem = reg.exec(html)
    const arr = []
    while (tem) {
      arr.push(tem[2])
      tem = reg.exec(html)
    }
    return arr
  },

  // 图片上传检查
  beforeImageUpload(img) {
    const isValid = (img.type === 'image/jpeg' || img.type === 'image/gif' || 'image/png')
    const isLt2M = img.size / 1024 / 1024 < 2
    if (!isValid) {
      this.$message.error('上传图片只能是JPG、PNG或GIF格式!')
    }
    if (!isLt2M) {
      this.$message.error('上传图片大小不能超过2MB!')
    }
    return isValid && isLt2M
  },

  // 文件上传检查
  beforeFileUpload(file) {
    const isLt10M = file.size / 1024 / 1024 < 10
    if (!isLt10M) {
      this.$message.error('上传文件大小不能超过10MB!')
    }
    return isLt10M
  },

  // 视频上传检查
  beforeVideoUpload(video) {
    const isValid = video.type.indexOf('video') !== -1
    const isLt10M = video.size / 1024 / 1024 < 20
    if (!isLt10M) {
      this.$message.error('上传视频大小不能超过20MB!')
    }
    if (!isValid) {
      this.$message.error('上传视频类型错误！')
    }
    return isLt10M && isValid
  },

  // 获取当前时间并格式化为“xxxx-xx-xx xx:xx:xx”的格式
  getNowFormatDate() {
    var date = new Date()
    var seperator1 = '-'
    var seperator2 = ':'
    var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    var strDate = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
    var strHour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
    var strMin = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
    var strSecond = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate + ' ' + strHour + seperator2 + strMin + seperator2 + strSecond
    return currentdate
  },

  // 时长格式化工具类：毫秒---> xx天xx小时xx分钟xx秒
  msFormatToDuration: ms => {
    if (ms) {
      const time = {
        day: Math.floor(ms / 86400000),
        hour: Math.floor(ms / 3600000) % 24,
        minute: Math.floor(ms / 60000) % 60,
        second: Math.floor(ms / 1000) % 60,
        millisecond: Math.floor(ms) % 1000
      }
      return (time.day > 0 ? time.day + '天' : '') + (time.hour > 0 ? time.hour + '小时' : '') + (time.minute > 0 ? time.minute + '分钟' : '') + (time.second > 0 ? time.second + '秒' : '') + (time.second === 0 ? '0秒' : '')
    }
  },
  // 时长格式化工具类：毫秒---> xx小时xx分钟xx秒
  secondFormatToDuration: sec => {
    if (sec) {
      const time = {
        hour: Math.floor(sec / 3600),
        minute: Math.floor(sec / 60) % 60,
        second: Math.floor(sec) % 60
      }
      return (time.hour > 0 ? time.hour + '小时' : '') + (time.minute > 0 ? time.minute + '分钟' : '') + (time.second > 0 ? time.second + '秒' : '0')
    }
  },

  // 随机生成uuid
  getRandomUid() {
    const s = []
    const hexDigits = '0123456789abcdef'
    // 取19位，加上时间戳的13位，构成32位uuid
    for (let i = 0; i < 19; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
    }
    s[14] = '4'
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
    s[8] = s[13] = s[18] = s[23]
    let uuid = s.join('')
    uuid = uuid + Date.now()
    return uuid
  },

  // 新消息系统提醒
  popNotice(title) {
    if (window.Notification) {
      // 当前聊天页面处于隐藏状态触发通知
      if (document.visibilityState === 'hidden' || this.$router.currentRoute.path !== '/chat') {
        Notification.requestPermission(p => {
          if (p === 'granted') {
            const notification = new Notification(title, {
              icon: './static/image/sys_tips_logo.png',
              tag: 'renotify',
              renotify: true
            })
            notification.onclick = () => {
              window.focus()
              // 定位到【当前会话页面】
              if (this.$router.currentRoute.path !== '/chat') {
                this.$router.push({ path: '/chat' }).catch(() => {})
              }
            }
          }
        })
      }
    } else {
      console.log('您的浏览器不支持Notification通知')
    }
  },

  // 防止坐席长时间未交互而导致的redis key和token过期
  refreshToken() {
    setInterval(() => {
      this.$http.post(window.$envUtils('VUE_APP_WB_SERVICE') + '/extraTime/agent/' + this.user.userInfo.id)
    }, 60 * 1000)
  }
}
export default commonUtils
